import { makeStyles } from '@rbx/ui';

const useEndpointContainerStyles = makeStyles()(() => ({
  descriptionContainer: {
    marginTop: 24,
  },

  pathContainer: {
    marginTop: 24,
  },

  sectionContainer: {
    marginTop: 32,
  },
}));

export default useEndpointContainerStyles;
